import type { LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui';

interface LegalPageProps {
  icon: LucideIcon;
  title: string;
  sections: { title: string; content: string }[];
}

export function LegalPage({ icon: Icon, title, sections }: LegalPageProps) {
  return (
    <div>
      <header className="ruled border-b border-line">
        <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 md:py-16">
          <div className="mb-5 inline-flex items-center gap-2 border-b border-accent pb-1">
            <Icon className="h-4 w-4 text-accent-ink" />
            <span className="label text-accent-ink">Legal</span>
          </div>
          <h1 className="text-section-mobile font-semibold tracking-heading md:text-section-desktop">{title}</h1>
        </div>
      </header>
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 md:py-14">
        <Card variant="raised" className="p-6 sm:p-8 md:p-10">
          <div className="space-y-8">
            {sections.map((s) => (
              <div key={s.title} className="border-l-2 border-line pl-4">
                <h2 className="mb-2 text-base font-semibold tracking-tight sm:text-lg">{s.title}</h2>
                <p className="text-sm leading-relaxed text-ink-2 sm:text-base">{s.content}</p>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
